import axios from "axios";
import {API_BASE_URL} from "constants/app";
import {Demographics} from "domain/types";

// Payload genérico para guías y formulario
export interface SurveyPayload {
    token: string;
    campaign: string;
    guide_id?: string;
    responses: Record<string, number | boolean>;
    demographics: Demographics;
}

// Este post es el que actualmente envia respuestas guia 2 y 3
export async function postSurveyResponse(payload: SurveyPayload) {
    return axios.post(`${API_BASE_URL}/api/v1/survey-responses`, payload);
}

